"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MapperBuilder_1 = require("./MapperBuilder");
class Payment extends MapperBuilder_1.default {
    constructor() {
        super();
        this.setStatus({
            PROCESSING: 'processing',
            AUTHORIZED: 'authorized',
            PAID: 'paid',
            REFUNDED: 'refunded',
            CHARGEDBACK: 'chargedback',
            WAITING_PAYMENT: 'waiting_payment',
            PENDING_REFUND: 'pending_refund',
            REFUSED: 'refused',
            CANCELED: 'canceled',
            TRIAL: 'trialing',
            WAITING_SCHEDULE: 'waiting_schedule',
            PAYMENT_ARREAR: 'payment_arrear',
        });
        this.setTranslations({
            [this.statusList.PROCESSING]: 'Processando',
            [this.statusList.AUTHORIZED]: 'Autorizado',
            [this.statusList.PAID]: 'Pago',
            [this.statusList.REFUNDED]: 'Estornado',
            [this.statusList.CHARGEDBACK]: 'Constestado',
            [this.statusList.WAITING_PAYMENT]: 'Aguardando pagamento',
            [this.statusList.PENDING_REFUND]: 'Estorno pendente',
            [this.statusList.REFUSED]: 'Recusado',
            [this.statusList.CANCELED]: 'Cancelado',
            [this.statusList.TRIAL]: 'Em avaliação',
            [this.statusList.WAITING_SCHEDULE]: 'Aguardando emissão',
            [this.statusList.PAYMENT_ARREAR]: 'Pagamento atrasado',
        });
        this.setAssertions({
            isPaid: this.buildAssertFunc(this.statusList.PAID),
            isCanceled: this.buildAssertFunc(this.statusList.CANCELED),
            isRefunded: this.buildAssertFunc(this.statusList.REFUNDED),
            isRefused: this.buildAssertFunc(this.statusList.REFUSED),
            isTrial: this.buildAssertFunc(this.statusList.TRIAL),
            isWaitingSchedule: this.buildAssertFunc(this.statusList.WAITING_SCHEDULE),
            isWaitingPayment: this.buildAssertFunc(this.statusList.WAITING_PAYMENT),
            isArrearPayment: this.buildAssertFunc(this.statusList.PAYMENT_ARREAR),
        });
    }
}
exports.default = Payment;
//# sourceMappingURL=Payment.js.map